import { Component } from '@angular/core';




@Component({
	selector: 'grid-text-editor',
	// old one
	// 	template: `
	// 	<select class="category">
	// 	<option  [value]="1">
	// 	 primary data
	// 	</option>
	// 	<option  [value]="2">
	// 	 primary data2
	// 	</option>
	//   </select>
	//     `,
	template: `
	<select class="category" [(ngModel)]="value" (change)="textUpdated()">
	<option *ngFor="let lp of LPs" [value]="lp.networkID" >
	{{lp.name}}
	</option>
	</select>
	`,
	styles: [`
    input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
  	-webkit-appearance: none;
	  margin: 0;
	}

	.grid-cell-edit-layout{
		height: 75% !important;
		width: 100% !important;
	
	}

	.invalid-text{
    border:2px solid  red !important;
	}`
	],
	standalone: false,  // NOSONAR
})

export class GridTextEditorComponent {
	public params: any;
	showInput = true;
	value: any;
	isEmpty = false;
	disableInput: boolean = false;
	type = "text";
	length = "10";
	lpChosen;
	LPs = [];

	public data: any;


	constructor() { }

	agInit(params: any): void {
		this.params = params;

		this.LPs = this.params.userData;

		this.data = this;

		console.info("this data in grid text editor", this.params.userData);


		if (this.params.column == 'primary') {  // NOSONAR
			if (this.data.params.data.primary) {
				this.value = this.data.params.data.primary;
			}
			else if (this.params.userData[0]) {
				this.value = this.params.userData[0].networkID;
			}
			else {
				this.value = '';
			}



			this.params.context.componentParent.saveUserinLPRow("primary", this.value, this.params.data.logisticspoint);


		}

		if (this.params.column == 'secondary') {  // NOSONAR

			if (this.data.params.data.secondary) {
				this.value = this.data.params.data.secondary;
			}
			else if (this.params.userData[0]) {
				this.value = this.params.userData[0].networkID;
			}
			else {
				this.value = '';
			}


			this.params.context.componentParent.saveUserinLPRow("secondary", this.value, this.params.data.logisticspoint);


		}

	}


	// called when the cell is refreshed
	refresh(params: any): boolean {
		this.params = params;
		this.LPs = this.params.userData;
		return true;
	}



	public textUpdated() {

		console.info("value", this.value);

		if (this.params.column == 'primary') {  // NOSONAR

			this.params.context.componentParent.saveUserinLPRow("primary", this.value, this.params.data.logisticspoint);

		}

		if (this.params.column == 'secondary') {  // NOSONAR

			this.params.context.componentParent.saveUserinLPRow("secondary", this.value, this.params.data.logisticspoint);

		}

	}


}
